import legalContent from './legalContent';

const fr = {
  room: {
    roomNumber: "Numéro de la salle",
    pseudo: "Pseudo",
    pseudoPlaceholder: "Votre pseudo",
    pseudoColor: "Couleur du pseudo",
    connection: "Connexion",
    pinAlphanumericError: "Le PIN doit contenir uniquement des lettres et des chiffres.",
    pinLengthError: "Le PIN doit contenir exactement 4 caractères.",
    pseudoRequiredError: "Veuillez entrer un pseudo.",
    pseudoLengthError: "Le pseudo doit contenir moins de 17 caractères ou il sera coupé",
    pinPlaceholder: "XXXX"
  },
  mediaSelect: {
    title: "Choisissez un type de média pour commencer la partie !",
    word: "Mot",
    image: "Image",
    video: "Vidéo",
    drawing: "Dessin"
  },
  ready: {
    title: "Êtes-vous prêt ?",
    button: "Démarrer",
    cancel: "Annuler",
    waitTitle: "En attente du démarrage...",
    starterTitle: "En attente des joueurs..."
  },
  answer: {
    title: "Réponse",
    placeholder: "Entrez votre réponse ici...",
    errorMessage: "Veuillez inscrire une réponse",
    submit: "Soumettre"
  },
  exportMot: {
    title: "Inscrivez un Mot!",
    placeholder: "Entrez votre mot ici...",
    submit: "Soumettre"
  },
  exportImage: {
    title: "Choisissez une image depuis votre appareil",
    chooseButton: "Choisir une image",
    zoomLabel: "Zoom :",
    moveFrame: "Déplacez le cadre",
    instructions: "Déplacez le cadre pour sélectionner la zone (500x500px)",
    instructionsSmall: "Utilisez le zoom pour ajuster - bordures ajoutées automatiquement",
    confirm: "Confirmer",
    successMessage: "Image confirmée et envoyée !"
  },
  exportVideo: {
    title: "Choisissez une vidéo",
    chooseButton: "Choisir une vidéo",
    compressionInProgress: "Compression en cours...",
    moveFrame: "Déplacez le cadre",
    cropInstructions: "Cliquez et glissez pour déplacer la zone de recadrage",
    timelineTitle: "Sélectionnez la partie à garder",
    timelineDuration: "max",
    zoomTitle: "Zoom de la zone (ratio 16:9)",
    zoomLabel: "Zoom :",
    currentArea: "Zone actuelle :",
    adjustInstructions: "Glissez les poignées ou le rectangle pour ajuster la sélection",
    confirm: "Confirmer",
    cancel: "Annuler",
    connectionLostError: "Connexion perdue. Veuillez recharger la page.",
    gifTooLargeError: "Même après conversion, le GIF dépasse",
    gifConversionError: "Erreur lors de la conversion du GIF.",
    durationCheckError: "Impossible de vérifier la durée de la vidéo.",
    metadataReadError: "Impossible de lire les métadonnées de la vidéo.",
    videoTooLargeError: "La vidéo éditée dépasse",
    videoProcessingError: "Erreur lors du traitement de la vidéo.",
    reduceMessage: "Réduisez la durée ou la zone."
  },
  exportVote: {
    title: "C'est à vous de voter !",
    alertMessage: "Veuillez sélectionner un joueur avant d'envoyer !",
    submit: "Envoyer"
  },
  canvas: {
    title: "À vos crayons !",
    colorLabel: "Couleur :",
    sizeLabel: "Taille :",
    fillMode: "Remplissage",
    undoButton: "Retour en arrière",
    clearButton: "Tout effacer",
    submit: "Envoyer"
  },
  waitingState: {
    title: "En attente des joueurs"
  },
  onTV: {
    title: "Regardez sur la télé"
  },
  restart: {
    title: "Voulez-vous recommencer ?",
    yes: "Oui",
    no: "Non"
  },
  reconnect: {
    title: "Reconnexion",
    message: "Voulez-vous vous reconnecter à la session ?",
    reconnectButton: "Se reconnecter",
    disconnectButton: "Se déconnecter"
  },
  footer: {
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité"
  },
  popup: {
    title: "Conditions d'utilisation et Politique de confidentialité",
    message: "Veuillez lire et accepter nos conditions d'utilisation et notre politique de confidentialité avant de continuer.",
    termsTitle: "Conditions d'utilisation",
    privacyTitle: "Politique de confidentialité",
    nextButton: "J'ai lu et j'accepte - Suivant",
    acceptButton: "J'ai lu et j'accepte",
    backButton: "Retour",
    termsContent: legalContent.fr.termsContent,
    privacyContent: legalContent.fr.privacyContent
  }
};

export default fr;